import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { StyledButton, UnstyledButton } from '../Button/PrivateButton';
import { StyledButtonLink, UnstyledButtonLink } from '../Button/PrivateButtonLink';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDropdownFooter = styled.div.withConfig({
  displayName: "DropdownFooter__StyledDropdownFooter",
  componentId: "sc-1dqxpff-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    paddingBlock: theme.space['400'],
    paddingInline: theme.space['500'],
    borderTop: `${theme.borderWidth['100']} solid ${theme.color['fill-accent-neutral-subtle-alt']}`,
    // Needs border token

    /**
     * Prevent duplicate padding
     */
    [`> ${StyledButton}, > ${UnstyledButton},> ${StyledButtonLink},> ${UnstyledButtonLink}`]: {
      padding: theme.space['0']
    }
  }, $cssStyles);
});
export const DropdownFooter = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledDropdownFooter, {
    $cssStyles: cssStyles,
    children: children
  });
};